export default defineNuxtRouteMiddleware(() => {
  const { $store, $config } = useNuxtApp()

  if ($store.auth.isLoggedIn) {
    const { is_superuser, is_super_typewriter } = $store.auth.authenticatedUser

    if (!is_super_typewriter && !is_superuser) {
      return navigateTo('/dashboard/home')
    }
  }
  else {
    const protocol = process.env.NODE_ENV === 'development' ? 'http' : 'https'
    return (window.location.href = `${protocol}://${$config.public.fullyQualifiedDomain}`)
  }
})
